import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import classNames from 'classnames'

import { getCurrentComponent } from 'shared/utils'

import { cancellationSelector, resultsSelector } from 'dashboard-transactions/selectors'
import { guestUserReservationsSelector } from 'manage-guest-user-booking/selectors'
import { languageSelector } from 'i18n/selectors'

import FindBooking from './FindBooking'
import GuestBookingDetails from './GuestBookingDetails'
import BookingCancelledPage from './BookingCancelledPage'

import styles from '../styles.module.scss'

const routeComponents = [
    <FindBooking key="manage-my-booking" />,
    <GuestBookingDetails key="manage-my-booking/details" />,
    <BookingCancelledPage key="manage-my-booking/cancelled" />,
]

const ManageGuestBookingPage = ({ cancellationInfo, results, reservationsToEdit }) => {
    const language = useSelector(languageSelector)
    const history = useHistory()

    const hideCommonHeading = history.location.pathname === `/${language}/manage-my-booking/cancelled` && 'd-none'
    const shouldRedirectToBaseRoute =
        history.location.pathname === `/${language}/manage-my-booking/details` &&
        Object.keys(reservationsToEdit).length === 0 &&
        !cancellationInfo.error

    const shouldRedirectToDetailsRoute =
        Object.keys(reservationsToEdit).length > 0 &&
        getCurrentComponent(routeComponents, history)?.key === 'manage-my-booking'

    React.useEffect(() => {
        if (shouldRedirectToDetailsRoute) {
            history.push(`/${language}/manage-my-booking/details`)
        }
    }, [reservationsToEdit])

    //when user manually using browser navigation from other routes navigates back to guest user booking flow , they should be navigated to initial route of the flow
    if (shouldRedirectToBaseRoute) {
        history.push(`/${language}/manage-my-booking`)
    }
    return (
        <div className={classNames('container text-center', styles.manageMyBookingContainer)}>
            <h2 className={`"text-uppercase" ${hideCommonHeading}`}>
                <T>manage.my.booking.heading</T>
            </h2>
            {getCurrentComponent(routeComponents, history)}
        </div>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            reservationsToEdit: guestUserReservationsSelector,
            cancellationInfo: cancellationSelector,
            results: resultsSelector,
        })
    )
)(ManageGuestBookingPage)
